
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoanApproveForm from './LoanApproveForm';
import { API_BASE_URL } from '../../config';
const GridILR = () => {
  const [showLoanApproveForm, setShowLoanApproveForm] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [loans, setLoans] = useState([]);
  const [firstRefinance, setFirstRefinanceLoans] = useState([]);
  const [secondRefinance, setSecondRefinanceLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('UPAS');
  // const [tableType, setTableType] = useState('UPAS'); 
  const handleCancel = () => {
    setShowLoanApproveForm(false);
  };

  // const handleLoanApproveClick = loan => {
  //   if (loan.status) {
  //     setSelectedLoan(loan);
  //     setShowLoanApproveForm(true);
  //   }
  // };

  // Function to handle loan approval click
  const handleLoanApproveClick = loan => {
    // || loan.status === 'offered'
    if (loan.status === 'pending') {
      setSelectedLoan(loan);
      setShowLoanApproveForm(true);
    }
  };

  // upas incoming get data
  const fetchLoans = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/account/all-loan-list/`,
        // 'https://finwise-backend.vercel.app/account/all-loan-list/',
        // 'https://finwiseback.finwise.com.bd/account/all-loan-list/',
        // 'http://127.0.0.1:8000/account/all-loan-list/',
        {
          headers: {
            Cookie:
              'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
          },
          withCredentials: true,
        }
      );
      setLoans(response.data);
      console.log(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching loans:', err);
      setError('Failed to fetch loan data. Please try again later.');
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLoans(); // Initial fetch

    const intervalId = setInterval(() => {
      fetchLoans(); // Fetch loans every 5 seconds
    }, 3000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);
  // first refinance incoming data
  const fetchFirstRefinanceLoans = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/account/first-refinance-loan-list/`,
        // 'https://finwise-backend.vercel.app/account/all-loan-list/',
        // 'https://finwiseback.finwise.com.bd/account/all-loan-list/',
        // 'http://127.0.0.1:8000/account/first-refinance-loan-list/',
        {
          headers: {
            Cookie:
              'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
          },
          withCredentials: true,
        }
      );
      setFirstRefinanceLoans(response.data);
      console.log(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching loans:', err);
      setError('Failed to fetch loan data. Please try again later.');
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchFirstRefinanceLoans(); // Initial fetch

    const intervalId = setInterval(() => {
      fetchFirstRefinanceLoans(); // Fetch loans every 5 seconds
    }, 3000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // first refinance incoming data
  const fetchSecondRefinanceLoans = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/account/all-second-refinance-loan/`,
        // 'https://finwise-backend.vercel.app/account/all-loan-list/',
        // 'https://finwiseback.finwise.com.bd/account/all-loan-list/',
        // 'http://127.0.0.1:8000/account/all-second-refinance-loan/',
        {
          headers: {
            Cookie:
              'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
          },
          withCredentials: true,
        }
      );
      setSecondRefinanceLoans(response.data);
      console.log(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching loans:', err);
      setError('Failed to fetch loan data. Please try again later.');
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSecondRefinanceLoans(); // Initial fetch

    const intervalId = setInterval(() => {
      fetchSecondRefinanceLoans(); // Fetch loans every 5 seconds
    }, 3000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // if (error) {
  //   return (
  //     <div>
  //       <p>{error}</p>
  //       <button onClick={() => window.location.reload()}>Retry</button>
  //     </div>
  //   );
  // }

  return (
    <div className="w-full lg:p-4 bg-white rounded-lg shadow-2xl">
      {showLoanApproveForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50  z-10"></div>
        // backdrop - blur - sm; if needed to bg-blur
      )}
      <h2 className="text-lg md:text-xl font-bold mb-4 text-gray-700 py-2 rounded-md text-center">
        Incoming UPAS/LC Requests
      </h2>
      {/* tab buttons */}
      <div className="flex space-x-0 mb-2 lg:text-lg 2xl:text-lg text-xs">
        <button
          className={`px-4 py-2 rounded-tl-md border-r border-gray-300 ${
            activeTab === 'UPAS' ? 'bg-headerBtn text-white' : 'bg-gray-100'
          }`}
          onClick={() => setActiveTab('UPAS')}
        >
          UPAS
        </button>
        <button
          className={`px-4 py-2 border-r border-gray-300 ${
            activeTab === 'FirstRefinance'
              ? 'bg-headerBtn text-white'
              : 'bg-gray-100'
          }`}
          onClick={() => setActiveTab('FirstRefinance')}
        >
          First Refinance
        </button>
        <button
          className={`px-4 py-2 rounded-tr-md ${
            activeTab === 'SecondRefinance'
              ? 'bg-headerBtn text-white'
              : 'bg-gray-100'
          }`}
          onClick={() => setActiveTab('SecondRefinance')}
        >
          Second Refinance
        </button>
      </div>

      {/* tab content */}
      {activeTab === 'UPAS' && (
        <div>
          {/* Table Code */}
          <div className="overflow-x-auto w-full text-xs md:text-sm">
            <div className="overflow-y-auto max-h-[560px]">
              <table className="w-full bg-white rounded-lg ">
                <thead className="bg-headerBtn text-white sticky top-0 z-0">
                  <tr>
                    <th className="py-2 px-4  rounded-tl-lg">ID</th>
                    <th className="py-2 px-4 ">LC Applicant</th>
                    <th className="py-2 px-4 ">Amount</th>
                    <th className="py-2 px-4 ">LC Value</th>
                    <th className="py-2 px-4 ">LC Maturity</th>
                    <th className="py-2 px-4 ">Tenor Required</th>
                    <th className="py-2 px-4 ">Document</th>
                    <th className="py-2 px-4 rounded-tr-lg">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loans.length > 0 ? (
                    loans.map((row, index) => (
                      <tr key={row.id} className="bg-AboutUsBg text-center">
                        {/* <td className="py-2 px-4 border-b">{row.id}</td> */}
                        <td className="py-2 px-4 rounded-tl-lg">{index + 1}</td>
                        <td className="py-2 px-4 ">{row.lc_applicant}</td>
                        <td className="py-2 px-4 ">${row.lc_value}</td>
                        <td className="py-2 px-4 ">{row.lc_currency}</td>
                        <td className="py-2 px-4 ">{row.lc_maturity}</td>
                        <td className="py-2 px-4 ">
                          {row.tenor_required} months
                        </td>
                        {/* <td className="py-2 px-4 ">{row.document}</td> */}
                        <td className="py-2 px-4">
                          {row.document ? (
                            <a
                              // href={row.document}
                              href={`${API_BASE_URL}${row.document}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View Document
                            </a>
                          ) : (
                            'No document'
                          )}
                        </td>
                        {/* <td className="py-2 px-4 border-b">
                    <button
                      onClick={() => handleLoanApproveClick(row)}
                      className={`px-3 py-1 rounded-md md:w-28 w-20 ${
                        row.is_approved
                          ? 'bg-green-500 text-white'
                          : row.is_pending
                          ? 'bg-yellow-500 text-white'
                          : 'bg-red-500 text-white'
                      }`}
                    >
                      {row.is_approved
                        ? 'Offered'
                        : row.is_pending
                        ? 'Pending'
                        : 'Cancelled'}
                    </button>
                  </td> */}
                        <td className="py-2 px-4">
                          <button
                            onClick={() => handleLoanApproveClick(row)}
                            className={`px-3 py-1 rounded-md md:w-28 w-20 ${
                              row.status === 'offered'
                                ? 'bg-green-500 text-white'
                                : row.status === 'pending'
                                ? 'bg-yellow-500 text-white'
                                : row.status === 'cancel'
                                ? 'bg-red-500 text-white'
                                : 'bg-gray-500 text-white'
                            }`}
                          >
                            {row.status === 'offered'
                              ? 'Offered'
                              : row.status === 'pending'
                              ? 'Pending'
                              : row.status === 'cancel'
                              ? 'Cancelled'
                              : 'Null'}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        <div className="flex items-center justify-center gap-2">
                          <p>No UPAS/LC available. </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'FirstRefinance' && (
        <div>
          {/* Table Code */}
          <div className="overflow-x-auto w-full text-xs md:text-sm">
            <div className="overflow-y-auto max-h-[560px]">
              <table className="w-full bg-white rounded-lg ">
                <thead className="bg-headerBtn text-white sticky top-0 z-0">
                  <tr>
                    <th className="py-2 px-4  rounded-tl-lg">ID</th>
                    <th className="py-2 px-4 ">UPAS Bank Name</th>
                    <th className="py-2 px-4 ">UPAS Maturity Date</th>
                    <th className="py-2 px-4 ">PI Document</th>
                    <th className="py-2 px-4 ">LC Document</th>
                    <th className="py-2 px-4 ">Acceptance Copy</th>
                    <th className="py-2 px-4 rounded-tr-lg">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {firstRefinance.length > 0 ? (
                    firstRefinance.map((row, index) => (
                      <tr key={row.id} className="bg-AboutUsBg text-center">
                        <td className="py-2 px-4 rounded-tl-lg">{index + 1}</td>
                        <td className="py-2 px-4 ">{row.UPAS_bank_name}</td>
                        <td className="py-2 px-4 ">{row.UPAS_maturity_date}</td>
                        <td className="py-2 px-4">
                          {row.PI_document ? (
                            <a
                              // href={row.PI_document}
                              href={`${API_BASE_URL}${row.PI_document}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View PI Document
                            </a>
                          ) : (
                            'No document'
                          )}
                        </td>

                        <td className="py-2 px-4">
                          {row.LC_document ? (
                            <a
                              // href={row.LC_document}
                              href={`${API_BASE_URL}${row.LC_document}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View LC Document
                            </a>
                          ) : (
                            'No document'
                          )}
                        </td>

                        <td className="py-2 px-4">
                          {row.Acceptance_copy ? (
                            <a
                              // href={row.Acceptance_copy}
                              href={`${API_BASE_URL}${row.Acceptance_copy}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View Acceptance Document
                            </a>
                          ) : (
                            'No document'
                          )}
                        </td>
                        <td className="py-2 px-4">
                          <button
                            onClick={() => handleLoanApproveClick(row)}
                            className={`px-3 py-1 rounded-md md:w-28 w-20 ${
                              row.status === 'offered'
                                ? 'bg-green-500 text-white'
                                : row.status === 'pending'
                                ? 'bg-yellow-500 text-white'
                                : row.status === 'cancel'
                                ? 'bg-red-500 text-white'
                                : 'bg-gray-500 text-white'
                            }`}
                          >
                            {row.status === 'offered'
                              ? 'Offered'
                              : row.status === 'pending'
                              ? 'Pending'
                              : row.status === 'cancel'
                              ? 'Cancelled'
                              : 'Null'}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        <div className="flex items-center justify-center gap-2">
                          <p>No UPAS/LC available. </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'SecondRefinance' && (
        <div>
          {/* Table Code */}
          <div className="overflow-x-auto w-full text-xs md:text-sm">
            <div className="overflow-y-auto max-h-[560px]">
              <table className="w-full bg-white rounded-lg ">
                <thead className="bg-headerBtn text-white sticky top-0 z-0">
                  <tr>
                    <th className="py-2 px-4  rounded-tl-lg">ID</th>
                    <th className="py-2 px-4 ">UPAS Bank Name</th>
                    <th className="py-2 px-4 ">UPAS Maturity Date</th>
                    <th className="py-2 px-4 ">Bank Name</th>
                    <th className="py-2 px-4 ">Maturity Date</th>
                    <th className="py-2 px-4 ">PI Document</th>
                    <th className="py-2 px-4 ">LC Document</th>
                    <th className="py-2 px-4 ">Acceptance Copy</th>
                    <th className="py-2 px-4 rounded-tr-lg">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {secondRefinance.length > 0 ? (
                    secondRefinance.map((row, index) => (
                      <tr key={row.id} className="bg-AboutUsBg text-center">
                        <td className="py-2 px-4 rounded-tl-lg">{index + 1}</td>
                        <td className="py-2 px-4 ">{row.UPAS_bank_name}</td>
                        <td className="py-2 px-4 ">{row.UPAS_maturity_date}</td>
                        <td className="py-2 px-4 ">{row.bank_name}</td>
                        <td className="py-2 px-4 ">{row.maturity_date}</td>
                        <td className="py-2 px-4">
                          {row.PI_document ? (
                            <a
                              // href={row.PI_document}
                              href={`${API_BASE_URL}${row.PI_document}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View PI Document
                            </a>
                          ) : (
                            'No document'
                          )}
                        </td>

                        <td className="py-2 px-4">
                          {row.LC_document ? (
                            <a
                              // href={row.LC_document}
                              href={`${API_BASE_URL}${row.LC_document}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View LC Document
                            </a>
                          ) : (
                            'No document'
                          )}
                        </td>

                        <td className="py-2 px-4">
                          {row.Acceptance_copy ? (
                            <a
                              // href={row.Acceptance_copy}
                              href={`${API_BASE_URL}${row.Acceptance_copy}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:underline"
                            >
                              View Acceptance Document
                            </a>
                          ) : (
                            'No document'
                          )}
                        </td>
                        <td className="py-2 px-4">
                          <button
                            onClick={() => handleLoanApproveClick(row)}
                            className={`px-3 py-1 rounded-md md:w-28 w-20 ${
                              row.status === 'offered'
                                ? 'bg-green-500 text-white'
                                : row.status === 'pending'
                                ? 'bg-yellow-500 text-white'
                                : row.status === 'cancel'
                                ? 'bg-red-500 text-white'
                                : 'bg-gray-500 text-white'
                            }`}
                          >
                            {row.status === 'offered'
                              ? 'Offered'
                              : row.status === 'pending'
                              ? 'Pending'
                              : row.status === 'cancel'
                              ? 'Cancelled'
                              : 'Null'}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        <div className="flex items-center justify-center gap-2">
                          <p>No UPAS/LC available. </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {showLoanApproveForm && (
        <div className="fixed inset-0 flex items-center justify-center z-30">
          <LoanApproveForm
            onClose={handleCancel}
            loanId={selectedLoan.id} // Pass the loan ID here
            // loanData={selectedLoan} // Pass the full loan data if needed
            tableType={activeTab} // Pass tableType as a prop
          />
        </div>
      )}
    </div>
  );
};

export default GridILR;
